import { Component, OnInit } from '@angular/core';
import Chart from 'chart.js/auto';
import { ShipmentSummaryService } from 'src/app/home/services/shipment-summary.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-shipment-summary',
  templateUrl: './shipment-summary.component.html',
  styleUrls: ['./shipment-summary.component.scss']
})
export class ShipmentSummaryComponent implements OnInit {

  public chartData: any;
 
  constructor(private route: ActivatedRoute, private shipmentSummaryService: ShipmentSummaryService) { }

  ngOnInit(): void {
    this.shipmentSummaryService.getChartData().subscribe({
      next: (res) => {
        this.chartData = res.data;
        this.generateChart();
      },
      error: (e) => console.error(e),
      complete: () => console.info('complete') 
    }
    );
  }

  generateChart(): void { 
    const ctx = document.getElementById('shipment-bar-chart') as HTMLCanvasElement;

    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.chartData.labels,
        datasets: this.chartData.datasets.map(dataset => ({
          label: dataset.label,
          data: dataset.data,
          backgroundColor: dataset.backgroundColor || '#2386DB',
          borderWidth: dataset.borderWidth || 1
        }))   
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
            position: 'top'
          },
          title: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y;
                }
                // return 'Consumed on ' + context.label + ': ' + label;
              }
            }
          }
        },
        scales: {
          x: {
            grid: {
              display: false 
            }
          },
          y: {
            grid: {
              display: true 
            },
            title: {
              display: true,
              text: 'Quantity', 
              align: 'center', 
              color: 'black',
              font: {
                size: 12 
              }
            },
            ticks: {
              // beginAtZero: true, // Ensure the y-axis starts at 0
              stepSize: 1, // Define the step size for the ticks
              callback: function(value) {
                return value; // Ensure the value is displayed as an integer
              } 
            },
            min: 0, // Set the minimum value
            max: 4
          }
        }
      }
    });
  } 
}
